module.exports = __webpack_public_path__ + "0f8a2ef519cab3c0ae1d91d0c3fd5368.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-1080.webp
// module id = 424
// module chunks = 0